export default function LoadingSkeleton({ count = 4 }) {
  return (
    <div className="space-y-4" data-testid="loading-skeleton">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="border border-[#E5E2D9] p-5 bg-white">
          <div className="flex items-center gap-2 mb-3">
            <div className="skeleton h-5 w-24 rounded-sm" />
            <div className="skeleton h-5 w-16 rounded-sm" />
          </div>
          <div className="skeleton h-6 w-3/4 rounded-sm mb-3" />
          <div className="skeleton h-4 w-full rounded-sm mb-2" />
          <div className="skeleton h-4 w-2/3 rounded-sm mb-3" />
          <div className="flex gap-4">
            <div className="skeleton h-3 w-20 rounded-sm" />
            <div className="skeleton h-3 w-28 rounded-sm" />
          </div>
        </div>
      ))}
    </div>
  );
}
